import React from 'react';
import { Application } from './Application';
import './AppsSorted.scss';
import { ILocationApplication } from '../../../shared/api/applications/applications';
import { IApplicationOperations } from './Apps';

interface IAppsSortedProps {
  applicationOperations: IApplicationOperations;
  applications: ILocationApplication[] | null;
  userProfiles: string[];
  form?: 'AZ' | 'Search';
}

const AppsSorted: React.FC<IAppsSortedProps> = ({ applicationOperations, applications, userProfiles, form = 'AZ' }) => {
  const getAppListChunks = (numberOfChunks: number): ILocationApplication[][] => {
    if (!applications) {
      return [];
    }
    const chunks: ILocationApplication[][] = [];
    const appsPerChunk = Math.ceil(applications.length / numberOfChunks);
    for (let i = 0; i < numberOfChunks - 1; i++) {
      chunks.push(applications.slice(i * appsPerChunk, (i + 1) * appsPerChunk));
    }
    chunks.push(applications.slice((numberOfChunks - 1) * appsPerChunk));
    return chunks;
  };

  return (
    <div className="AZList ms-slideDownIn10">
      {applications &&
        getAppListChunks(3).map((appChunk: ILocationApplication[], index: number) => (
          <div key={index} className="Column">
            {appChunk.map(a => (
              <Application
                userProfiles={userProfiles}
                application={a}
                key={a.id}
                applicationOperations={applicationOperations}
                form={form}
              />
            ))}
          </div>
        ))}
    </div>
  );
};

export default AppsSorted;
